import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = (cityId) => ['shutdownCompanies', cityId];

const shutdownCompaniesQuery = async ({ queryKey }) => {
  const [_, cityId] = queryKey;

  return await request.get(
    `/Request/companies`,
    { cityId },
    `При загрузке управляющих компаний произошла ошибка`
  );
};

export const useShutdownCompanies = (cityId, options) =>
  useQuery(key(cityId), shutdownCompaniesQuery, options);
